import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import * as R from 'ramda'

import { TAB_NAMES } from 'components/pages/Templates/model'
import { toTemplates } from 'ducks/router'
import { useTable } from 'hooks'
import { interviewTemplates } from 'orm'
import { getColumns, getRowActions } from './model'

const useInterviewsTableMutations = () => {
  const dispatch = useDispatch()

  const handleFetchInterviewTemplates = React.useCallback(
    ({ limit, department, offset, ordering, search }) => {
      dispatch(
        interviewTemplates.fetchStart({
          limit,
          department,
          offset,
          ordering,
          search,
        }),
      )
    },
    [dispatch],
  )

  return {
    handleFetchInterviewTemplates,
  }
}

const useInterviewsTableData = () => {
  const data = useSelector(interviewTemplates.getModel)

  const { count, items = [], order = [] } = data ?? {}

  return {
    state: { count, items, order },
  }
}

export const useInterviewsTable = state => {
  const { mapSortingPropToQueryParam, search, filter } = state

  const dispatch = useDispatch()

  const columns = getColumns()
  const rowActions = getRowActions()

  const { handleFetchInterviewTemplates } = useInterviewsTableMutations()

  const {
    state: { count, items, order },
  } = useInterviewsTableData()

  const handleRefetch = React.useCallback(
    ({ limit, department, offset, ordering, search }) => {
      handleFetchInterviewTemplates({
        limit,
        department,
        offset,
        ordering,
        search,
      })
    },
    [handleFetchInterviewTemplates],
  )

  const handleQueriesUpdate = React.useCallback(
    ({ limit, department, offset, ordering, search }) => {
      dispatch(
        toTemplates(TAB_NAMES.INTERVIEWS, null, {
          limit,
          department,
          offset,
          ordering,
          search,
        }),
      )
    },
    [dispatch],
  )

  const {
    state: {
      pagination: { currentPage, pageCount, perPage },
      table: { headers, model, isFetching },
    },
    handlers: {
      pagination: { handlePage, handlePageSize },
    },
  } = useTable({
    columns,
    data: R.props(order, items),
    mapSortingPropToQueryParam,
    pageCount: count,
    filterQuery: filter,
    search,
    fetchAction: handleRefetch,
    updateQueriesAction: handleQueriesUpdate,
  })

  return {
    state: {
      pagination: { currentPage, pageCount, perPage },
      table: {
        headers,
        model,
        rowActions,
        isFetching,
      },
    },
    handlers: {
      pagination: { handlePage, handlePageSize },
    },
  }
}
